import React from "react";
import { RouterProvider } from "react-router-dom";
import "./App.css";
import { MainRouter } from "./constants/routes";
import { UserProvider } from "./context/UserContext";
function App() {


  return (
  <UserProvider>
    <RouterProvider router={MainRouter} />
    </UserProvider>
  );
}

export default App;
